export class Agreement {
    html = '';
}
